import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from './scenes/GameIntro';

interface PhaserCakeDecoratingGameProps {
    onComplete: () => void;
}

interface PhaserCakeDecoratingGameState {
}

const gameConfig: GameConfig = {
    title: "Cake Decorating Game",
    version: "0.2",
    backgroundColor: "#000000",
};

class PhaserCakeDecoratingGame extends React.Component<PhaserCakeDecoratingGameProps, PhaserCakeDecoratingGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserCakeDecoratingGameProps) {
        super(props);
        bindAllOfThis(this, PhaserCakeDecoratingGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserCakeDecoratingGame;



// WEBPACK FOOTER //
// ./src/games/CakeDecorating/Main.tsx